import styled from 'styled-components';
import { ReactComponent as RawPinSVG } from '../../../../assets/icons/icon_pin.svg';

export const IconPin = styled(RawPinSVG)``;
